export const buildCrossDomainLink = ({ baseUrl, path = '/', lang = 'en' }) => {
    const normalizedBase = baseUrl.replace(/\/+$/, '');
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;

    const url = new URL(`${normalizedBase}${normalizedPath}`);
    url.searchParams.set('lang', lang);

    return url.toString();
};